import { Box, Typography } from '@mui/material';

const GameSectionWins = ({ game }) => {
  const getTeamById = (teamId) => {
    return game.teams.teamA.id === teamId ? game.teams.teamA : game.teams.teamB;
  };

  const teamName = (team) => {
    if (team.name) {
      return <Typography variant="caption">{team.name}</Typography>;
    }

    return team.players?.map((player, index) => (
      <Typography key={index} variant="caption">
        {player}
      </Typography>
    ));
  };

  return (
    <Box display="flex" flexDirection="row" gap={3} justifyContent={'center'} alignItems={'center'}>
      {game.sets?.map((set, index) => {
        return set.isDone ? (
          !set.isDraw ? (
            <Box key={index}>
              <Typography variant="caption">
                Set {set.setNumber}: {teamName(getTeamById(set.winningId))}
              </Typography>
            </Box>
          ) : (
            <Box key={index}>
              <Typography variant="caption">Set {set.setNumber}: Draw</Typography>
            </Box>
          )
        ) : null;
      })}
    </Box>
  );
};

export default GameSectionWins;
